export function getDomain(type: "transformless" | "with-transformations") {
    if (type === "with-transformations") {
        return "images.holibob.tech";
    }
    return "files.holibob.tech";
}
